/**
 * Get the closest matching element up the DOM tree.
 * @deprecated since version 2.5.0
 * @private
 * @param  {Element} elem     Starting element
 * @param  {String}  selector Selector to match against
 * @return {Boolean|Element}  Returns null if not match found
 */
export default function (elem, selector) {
    return elem.closest(selector);
};